import React, { useEffect } from "react";
import { IonPage, IonSplitPane } from "@ionic/react";

import { useHistory } from "react-router";
import InternalRoutes from "../routes/internal";

import { WSconnect, WSdisconnect, WSemit, WSlisten } from "services/socket";
import { connect } from "react-redux";
import AppMenu from "../components/Menu/AppMenu";
import { requireAuth } from "../components/auth";
import QuizController from "controllers/quizController";
import ChromeCastButtons from "components/ChromeCastButtons";

import { setWsConnection } from "services/general/actions";
import { resetStore, setProgress, updateProgress } from "services/quiz";
import { addTeam, updateStoreTeam, removeTeam } from "services/teams";
import { showBreakerRound } from "services/util";
import config from "config";
import { logoutUser } from "services/users";
import ChromeCast from "services/chromecast";

interface Props {
  loggedIn: any;
  userDetails: any;
  children: any;
  user: any;
  quizData: any;
  setProgress: Function;
  updateProgress: Function;
  addTeam: Function;
  updateStoreTeam: Function;
  removeTeam: Function;
  setWsConnection: Function;
  wsStatus: string;
  resetStore: Function;
  logoutUser: Function;
}

const InternalLayout: React.FC<Props> = ({
  loggedIn,
  user,
  quizData,
  setProgress,
  updateProgress,
  addTeam,
  updateStoreTeam,
  removeTeam,
  setWsConnection,
  wsStatus,
  resetStore,
  logoutUser,
}) => {
  const history = useHistory();
  const { customerId, adUrls, assignedPrizes, customPrizes } = user.userDetails;
  const { quizId, progress } = quizData;
  const { page, round } = quizData.progress;
  const prizes = (assignedPrizes?.length || 0) + (customPrizes?.length || 0);
  const hasAds = adUrls && adUrls.length > 0;
  const mode = quizData.progress.output?.mode || "quiz";
  const introPage = quizData.progress.output?.page || 0;
  const hasBreaker = quizData.quizConfig?.format?.hasBreaker || false;
  const isCrossword = quizData.quizConfig?.format?.isCrossword || false;

  useEffect(() => {
    if (customerId && quizId) {
      WSconnect()
        .then(() => {
          setWsConnection("connected");
        })
        .catch((err) => {
          setWsConnection("disconnected");
        });
    }

    return () => {
      WSdisconnect();
    };
    //eslint-disable-next-line
  }, [customerId, quizId]);

  useEffect(() => {
    WSlisten("connect", () => {
      setWsConnection("connected");
    });
    WSlisten("disconnect", () => {
      setWsConnection("disconnected");
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!loggedIn) {
      history.push("/login");
    } else {
      history.push("/dashboard");
    }
    //eslint-disable-next-line
  }, [loggedIn]);

  useEffect(() => {
    const responseTimeout = 10000;
    WSlisten("getProgress", async (msg: any) => {
      msg.data.output = await JSON.parse(msg.data.output);
      setProgress(msg.data);
      // setLoading(false);
      clearTimeout(responseTimer);
    });

    const responseTimer = setTimeout(() => {
      //setErrorMessage(
      //   "WebSocket did not respond. Please contact system administrator."
      // );
      //setError(true);
      // setLoading(false);
    }, responseTimeout);

    WSlisten("updateProgress", (msg: any) => {
      // console.log(msg);
      updateProgress(msg);
    });

    WSlisten("updateMusicActive", (msg: any) => {
      updateProgress({ musicActive: msg.musicActive });
    });

    WSlisten("nextSong", (msg: any) => {
      updateProgress({ playlistPosition: msg.playlistPosition });
    });

    WSlisten("getTeams", (msg: any) => {
      if (msg.data && msg.data.length > 0) {
        msg.data.forEach((item: any) => {
          addTeam(item.teamData);
        });
      }
    });

    WSlisten("createTeam", (msg: any) => {
      //console.log("createTeam", msg.teamData);
      const values = msg.teamData;
      addTeam({
        ...values,
        teamStatusId: msg.teamStatusId,
      });
    });

    WSlisten("updateTeam", (msg: any) => {
      updateStoreTeam(msg.data);
    });

    WSlisten("removeTeam", (id: number) => {
      removeTeam(id);
    });

    WSlisten("clearData", () => {
      ChromeCast.quit();
      resetStore();
      logoutUser();
    });

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (quizId && customerId) {
      WSemit("updateConstants", {
        quizId,
        customerId,
        constants: {
          ...config.CONSTANTS,
        },
      });
    }

    //eslint-disable-next-line
  }, [config.INTRO_SLIDE_TIME]);

  useEffect(() => {
    if (customerId && quizId) {
      WSemit("getProgress", {
        quizId,
        customerId,
        isController: true,
        constants: {
          adSlideTime: config.INTRO_SLIDE_TIME,
          slideTime: config.INTRO_SLIDE_TIME,
        },
      });
      WSemit("getTeams", { quizId, customerId });
    }
    //eslint-disable-next-line
  }, [customerId, quizId]);

  enum IntroPages {
    ROUNDS = 0,
    PRIZES = 1,
    TEAMS = 2,
    ADS = 3,
  }

  const getProgress = () => {
    return progress;
  };

  // INTRO CYCLE
  useEffect(() => {
    let timer: any;
    if (mode === "intro") {
      timer = setTimeout(
        () => {
          console.log(prizes);
          let currentProg = getProgress();
          let nextPage = IntroPages.ROUNDS;
          const introPosition = currentProg.output.position;
          let nextPosition = introPosition;

          switch (introPage) {
            case IntroPages.ROUNDS:
              if (prizes) nextPage = IntroPages.PRIZES;
              else nextPage = IntroPages.TEAMS;
              break;
            case IntroPages.PRIZES:
              nextPage = IntroPages.TEAMS;
              break;
            case IntroPages.TEAMS:
              if (hasAds) nextPage = IntroPages.ADS;
              else nextPage = IntroPages.ROUNDS;
              break;
            case IntroPages.ADS:
              nextPosition =
                adUrls.length - 1 > introPosition
                  ? (introPosition % adUrls.length) + 1
                  : 0;

              if (nextPosition === 0) nextPage = IntroPages.ROUNDS;
              else nextPage = IntroPages.ADS;

              break;
            default:
              break;
          }

          WSemit("updateProgress", {
            location: "introCycle",
            ...currentProg,
            output: { mode: "intro", page: nextPage, position: nextPosition },
          });
        },
        introPage === IntroPages.ADS
          ? config.INTRO_AD_TIME
          : config.INTRO_SLIDE_TIME
      );

      return () => {
        if (timer) {
          clearTimeout(timer);
        }
      };
    }
    //eslint-disable-next-line
  }, [progress]);

  // END OF ROUND CYCLE
  useEffect(() => {
    let timer: any;

    // If breaker question or Crossword question
    if (
      (mode === "quiz" &&
        progress.section === "crossword" &&
        page === "question") ||
      (mode === "quiz" && progress.section === "breaker" && page === "question")
    ) {
      let timeout = config.END_ROUND_SLIDE_TIME;
      if (
        mode === "quiz" &&
        progress.section === "crossword" &&
        page === "question" &&
        round === 1
      ) {
        timeout = config.ROUND_1_CW_TIME;
      }
      timer = setTimeout(() => {
        let currentProg = getProgress();
        WSemit("updateProgress", {
          location: "endRoundCycle",
          ...currentProg,
          section:
            progress.section === "crossword" &&
            hasBreaker &&
            showBreakerRound(quizData.quizConfig, round)
              ? "breaker"
              : "ad",
          page: "question",
        });
      }, timeout);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
    //eslint-disable-next-line
  }, [progress]);

  //AD SEQUENCE TIMING
  useEffect(() => {
    let timer: any;
    if (mode === "quiz" && progress.section === "ad") {
      let timeout = config.END_ROUND_AD_TIME;

      if (adUrls && adUrls.length > 1) {
        timer = setTimeout(() => {
          const newPosition =
            adUrls.length - 1 > progress.position
              ? (progress.position % adUrls.length) + 1
              : 0;
          let currentProg = getProgress();

          if (
            newPosition === 0 &&
            mode === "quiz" &&
            progress.section === "ad"
          ) {
            // END OF END OF ROUND AD SEQUENCE
            WSemit("updateProgress", {
              location: "endRoundAdCycle",
              ...currentProg,
              section: isCrossword
                ? "crossword"
                : hasBreaker && showBreakerRound(quizData.quizConfig, round)
                ? "breaker"
                : "ad",
              page: "question",
              position: newPosition,
            });
          } else {
            // AD SEQUENCE
            WSemit("updateProgress", {
              ...currentProg,
              position: newPosition,
            });
          }
        }, timeout);

        return () => {
          if (timer) {
            clearTimeout(timer);
          }
        };
      }
    }
    //eslint-disable-next-line
  }, [adUrls, introPage, progress]);

  if (loggedIn === true) {
    return (
      <IonSplitPane id="main-content" contentId="main-content" when="lg">
        <QuizController />
        <AppMenu />
        <IonPage id="main-content">
          <InternalRoutes />
          <ChromeCastButtons />
        </IonPage>
      </IonSplitPane>
    );
  } else return null;
};

const mapStateToProps = (state: any) => ({
  loggedIn: state.user.loggedIn,
  user: state.user,
  quizData: state.quiz,
  wsStatus: state.general.wsStatus,
});

export default connect(mapStateToProps, {
  setProgress,
  updateProgress,
  addTeam,
  updateStoreTeam,
  removeTeam,
  setWsConnection,
  resetStore,
  logoutUser,
})(requireAuth(InternalLayout));
